import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=64d6a046&scoped=true"
import script from "./applicationList.vue?vue&type=script&lang=js"
export * from "./applicationList.vue?vue&type=script&lang=js"
import style0 from "./applicationList.vue?vue&type=style&index=0&id=64d6a046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6a046",
  null
  
)

export default component.exports